import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import gsap from "gsap";
import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
import { MouseBlocker } from "@lib/titan2/dist/game/control/MouseBlocker";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
import { resetTitanSpine, skipToEnd } from "../../../utils/SpineUtils";
import { GameSoundLiftEvents } from "../../../controller/event/GameSountEvent";
export class GameMainTransition extends AbstractGameView {
    create() {
        super.create();
        this.blackout = new MouseBlocker(new MouseBlockerProperties(0x000000, 1));
        this.blackout.alpha = 0;
        this.blackout.interactive = this.blackout.interactiveChildren = false;
        this.addChild(this.blackout);
        this.transitionSpine = TitanSpine.createSpine(this, "elevator", this.landscapeProperties.transitionSpine, this.portraitProperties.transitionSpine);
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(MainTransitionEvents.TRANSITION_INTRO_START, this.handleTransitionIntroStart);
        this.registerGame(MainTransitionEvents.TRANSITION_OUTRO_START, this.handleTransitionOutroStart);
        this.registerGame(MainTransitionEvents.BLACKOUT_START, this.handleBlackoutStart);
    }
    handleTransitionIntroStart() {
        resetTitanSpine(this.transitionSpine);
        this.transitionSpine.interactive = true;
        this.dispatchGame(GameSoundLiftEvents.BEGIN_LOOP);
        SpineUtil.play(this.transitionSpine, "Intro", () => {
            const matchedPatterns = this.model.getCurrentMatchedPatterns();
            const animation = matchedPatterns < 10 ? `Floor 0${matchedPatterns}` : `Floor ${matchedPatterns}`;
            SpineUtil.play(this.transitionSpine, animation, undefined, undefined, 0);
            //Wait a little for doors to begin closing. We dont get a spine event.
            gsap.delayedCall(0.2, () => this.dispatchGame(GameSoundLiftEvents.CLOSE_LIFT));
            this.dispatchGame(MainTransitionEvents.TRANSITION_INTRO_COMPLETE);
        }, undefined, 0);
    }
    handleTransitionOutroStart() {
        skipToEnd(this.transitionSpine);
        this.dispatchGame(GameSoundLiftEvents.END_LOOP);
        this.dispatchGame(GameSoundLiftEvents.PLAY_BELL);
        gsap.delayedCall(0.25, () => this.dispatchGame(GameSoundLiftEvents.OPEN_LIFT));
        SpineUtil.play(this.transitionSpine, "Outro", () => {
            this.transitionSpine.interactive = false;
            this.dispatchGame(MainTransitionEvents.TRANSITION_OUTRO_COMPLETE);
        }, undefined, 1);
    }
    async handleBlackoutStart() {
        await gsap.to(this.blackout, { alpha: 1, duration: 0.5 });
        this.dispatchGame(MainTransitionEvents.BLACKOUT_MID_POINT);
        await gsap.to(this.blackout, { alpha: 0, duration: 0.5 });
        this.dispatchGame(MainTransitionEvents.BLACKOUT_COMPLETE);
    }
}
export class MainTransitionEvents {
}
MainTransitionEvents.TRANSITION_INTRO_START = new EventObject("MainTransitionEvents.TRANSITION_INTRO_START");
MainTransitionEvents.TRANSITION_INTRO_COMPLETE = new EventObject("MainTransitionEvents.TRANSITION_INTRO_COMPLETE");
MainTransitionEvents.TRANSITION_OUTRO_START = new EventObject("MainTransitionEvents.TRANSITION_OUTRO_START");
MainTransitionEvents.TRANSITION_OUTRO_COMPLETE = new EventObject("MainTransitionEvents.TRANSITION_OUTRO_COMPLETE");
MainTransitionEvents.BLACKOUT_START = new EventObject("MainTransitionEvents.BLACKOUT_START");
MainTransitionEvents.BLACKOUT_MID_POINT = new EventObject("MainTransitionEvents.BLACKOUT_MID_POINT");
MainTransitionEvents.BLACKOUT_COMPLETE = new EventObject("MainTransitionEvents.BLACKOUT_COMPLETE");
//# sourceMappingURL=GameMainTransition.js.map